<main class="relative flex flex-col pt-14 lg:pt-18">
  <!-- 상단 배너 -->
  <div class="relative w-full">
    <img src="/customer/top-bg-mo.svg" alt="top background" class="w-full flex lg:hidden" />
    <img src="/customer/top-bg-pc.svg" alt="top background" class="w-full hidden lg:flex" />

    <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-4">
      <p class="sb-aggro text-white/80 font-light text-xs">홈 &gt; 참가브랜드</p>
      <h1 class="text-white text-2xl lg:text-4xl">참가브랜드</h1>
      <p class="text-white font-medium">창업 박람회의 참가브랜드를 확인해보세요.</p>
    </div>
  </div>

  <!-- 세그먼트 탭 -->
  <div class="bg-white sticky top-14 lg:top-18 z-10">
    <div class="relative">
      <div class="promotion-tabs lg:px-0 lg:max-w-6xl lg:mx-auto">
        <button
          id="tab-brands"
          class="tab sb-aggro text-base font-light px-4!"
          [class.active]="selectedTab() === 'brands'"
          (click)="changeTab('brands')">
          참가브랜드
        </button>
        <button
          id="tab-past-events"
          class="tab sb-aggro text-base font-light px-4!"
          [class.active]="selectedTab() === 'past-events'"
          (click)="changeTab('past-events')">
          지난 박람회
        </button>
      </div>
    </div>
  </div>

  <!-- 본문 -->
  <div class="flex flex-col gap-4 lg:gap-10 px-4 lg:px-0 lg:max-w-6xl lg:mx-auto py-6 lg:py-12 w-full">
    <!-- ══════════════════════════════════ 참가브랜드 탭 ══════════════════════════════════ -->
    @if (selectedTab() === 'brands') {
    <!-- 검색 및 TOTAL 영역 -->
    <div class="flex flex-col gap-3 lg:flex-row lg:justify-between lg:items-center">
      <div class="flex items-center gap-1">
        <span class="text-zinc-800 text-sm">TOTAL</span>
        <span class="text-primary-500 text-sm">{{ totalCount() }}</span>
      </div>
      <div class="search-box">
        <app-icon name="ic:round-search" class="size-5! text-zinc-400"></app-icon>
        <input type="text" placeholder="업체명으로 검색" [value]="query()" (input)="onSearch($event)" />
      </div>
    </div>

    <!-- ── 모바일: 무한스크롤 -->
    @if (isMobile()) {
    <div>
      <app-infinite-scroll
        [hasMore]="moBrandsHasMore()"
        [isLoading]="$moBrandsAll.isLoading()"
        (loadMore)="loadMoreBrands()">
        <div class="grid grid-cols-2 gap-4">
          @for (item of moBrandsList(); track item.id) {
          <a
            [routerLink]="[item.id]"
            class="brand-card col-span-1 bg-white rounded-2xl overflow-hidden cursor-pointer border border-zinc-200 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 group">
            <div class="flex flex-col h-full">
              <div
                class="relative w-full aspect-4/3 overflow-hidden bg-zinc-100 flex items-center justify-center text-zinc-300">
                <div class="absolute inset-0 flex flex-col items-center justify-center z-0">
                  <app-icon name="mdi:image-outline" class="size-10 mb-1"></app-icon>
                  <span class="text-xs font-medium">No Image</span>
                </div>
                @if (item.thumbnail) {
                <img
                  [src]="item.thumbnail"
                  (error)="$any($event.target).style.display = 'none'"
                  [alt]="item.companyName"
                  class="absolute inset-0 z-10 w-full h-full object-cover bg-zinc-100" />
                }
              </div>
              <div class="flex flex-col gap-1 px-3 py-3 items-center justify-center flex-1 bg-zinc-50/50">
                <h2 class="sb-aggro text-zinc-800 font-bold text-sm line-clamp-2 text-center">
                  {{ item.companyName }}
                </h2>
                @if (item.shortDescription) {
                <p class="text-zinc-500 text-xs line-clamp-1 text-center">{{ item.shortDescription }}</p>
                }
              </div>
            </div>
          </a>
          } @empty { @if (!$moBrandsAll.isLoading()) {
          <app-not-found [(query)]="query" [isLoading]="$moBrandsAll.isLoading()" class="col-span-2">
            <span class="text-zinc-500 text-base">참가업체가 없습니다.</span>
          </app-not-found>
          } }
        </div>
      </app-infinite-scroll>
    </div>

    } @else {
    <!-- ── PC: 페이지네이션 ── -->
    <div>
      <div class="grid grid-cols-4 gap-6">
        @for (item of list(); track item.id) {
        <a
          [routerLink]="[item.id]"
          class="brand-card col-span-1 bg-white rounded-2xl overflow-hidden cursor-pointer border border-zinc-200 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 group">
          <div class="flex flex-col h-full">
            <div
              class="relative w-full aspect-4/3 overflow-hidden bg-zinc-100 flex items-center justify-center text-zinc-300 transition-opacity group-hover:opacity-95">
              <div
                class="absolute inset-0 flex flex-col items-center justify-center group-hover:scale-105 transition-transform duration-500 z-0">
                <app-icon name="mdi:image-outline" class="size-12 mb-2"></app-icon>
                <span class="text-xs font-medium">No Image</span>
              </div>
              @if (item.thumbnail) {
              <img
                [src]="item.thumbnail"
                (error)="$any($event.target).style.display = 'none'"
                [alt]="item.companyName"
                class="absolute inset-0 z-10 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 bg-zinc-100" />
              }
            </div>
            <div class="flex flex-col gap-1 px-4 py-5 items-center justify-center flex-1 bg-zinc-50/50">
              <h2
                class="sb-aggro text-zinc-800 font-bold text-lg line-clamp-2 text-center transition-colors duration-200 group-hover:text-primary-600">
                {{ item.companyName }}
              </h2>
              @if (item.shortDescription) {
              <p class="text-zinc-500 text-sm line-clamp-1 text-center">{{ item.shortDescription }}</p>
              }
            </div>
          </div>
        </a>
        } @empty {
        <app-not-found [(query)]="query" [isLoading]="$data.isLoading()" class="col-span-4">
          <span class="text-zinc-500 text-base">참가업체가 없습니다.</span>
        </app-not-found>
        }
      </div>

      @if (list().length > 0) {
      <app-pagination
        [currentPage]="currentPage()"
        [totalPages]="totalPages()"
        (pageChange)="onPageChange($event)"
        class="flex mt-10" />
      }
    </div>
    }
    }

    <!-- ══════════════════════════════════ 지난박람회 탭 ══════════════════════════════════ -->
    @if (selectedTab() === 'past-events') {
    <!-- TOTAL -->
    <div class="flex items-center gap-1">
      <span class="text-zinc-800 text-sm">TOTAL</span>
      <span class="text-primary-500 text-sm">{{ pastTotalCount() }}</span>
    </div>

    <!-- ── 모바일: 무한스크롤 -->
    @if (isMobile()) {
    <div>
      <app-infinite-scroll [hasMore]="moPastHasMore()" [isLoading]="$moPastAll.isLoading()" (loadMore)="loadMorePast()">
        <div class="grid grid-cols-1 gap-4">
          @for (event of moPastList(); track event.id) {
          <a
            [routerLink]="['/event', event.id]"
            class="group bg-white rounded-2xl overflow-hidden border border-zinc-200 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
            <div class="relative w-full aspect-square overflow-hidden bg-zinc-100">
              @if (event.thumbnail) {
              <img [src]="event.thumbnail" [alt]="event.title" class="w-full h-full object-cover" />
              } @else {
              <div class="absolute inset-0 flex flex-col items-center justify-center text-zinc-300">
                <app-icon name="material-symbols:image-outline-rounded" class="size-10 mb-1"></app-icon>
                <span class="text-xs font-medium">No Image</span>
              </div>
              }
              <span
                class="absolute top-2 left-2 rounded-full bg-zinc-700/80 backdrop-blur-sm px-2 py-0.5 text-[10px] font-bold text-white">
                종료
              </span>
            </div>
            <div class="flex flex-col gap-1.5 px-3 py-3">
              <h2
                class="sb-aggro text-zinc-800 font-bold text-xl line-clamp-2 group-hover:text-primary-600 transition-colors">
                {{ event.title }}
              </h2>
              <div class="flex flex-col gap-0.5 text-zinc-500 text-base">
                <div class="flex items-center gap-1">
                  <app-icon name="material-symbols:calendar-month-rounded" class="size-4! shrink-0" />
                  <span class="line-clamp-1">{{ formatDateRange(event.startAt, event.endAt) }}</span>
                </div>
                @if (event.place.name) {
                <div class="flex items-center gap-1">
                  <app-icon name="material-symbols:location-on-rounded" class="size-4! shrink-0" />
                  <span class="line-clamp-1">{{ event.place.name }}</span>
                </div>
                }
              </div>
            </div>
          </a>
          } @empty { @if (!$moPastAll.isLoading()) {
          <app-not-found [isLoading]="$moPastAll.isLoading()" class="col-span-2">
            <span class="text-zinc-500 text-base">지난 박람회 내역이 없습니다.</span>
          </app-not-found>
          } }
        </div>
      </app-infinite-scroll>
    </div>
    } @else {
    <!-- ── PC: 페이지네이션 ── -->
    <div>
      <div class="grid grid-cols-4 gap-6">
        @for (event of pastEvents(); track event.id) {
        <a
          [routerLink]="['/event', event.id]"
          class="group bg-white rounded-2xl overflow-hidden border border-zinc-200 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:shadow-lg">
          <div class="relative w-full aspect-square overflow-hidden bg-zinc-100">
            @if (event.thumbnail) {
            <img
              [src]="event.thumbnail"
              [alt]="event.title"
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            } @else {
            <div class="absolute inset-0 flex flex-col items-center justify-center text-zinc-300">
              <app-icon name="material-symbols:image-outline-rounded" class="size-12 mb-2"></app-icon>
              <span class="text-xs font-medium">No Image</span>
            </div>
            }
            <span
              class="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-zinc-700/80 backdrop-blur-sm px-2.5 py-1 text-[11px] font-bold text-white">
              종료
            </span>
          </div>
          <div class="flex flex-col gap-2 px-4 py-4">
            <h2
              class="sb-aggro text-zinc-800 font-bold text-base line-clamp-2 group-hover:text-primary-600 transition-colors">
              {{ event.title }}
            </h2>
            <div class="flex flex-col gap-1 text-zinc-500 text-sm">
              <div class="flex items-center gap-1.5">
                <app-icon name="material-symbols:calendar-month-rounded" class="size-4! shrink-0" />
                <span>{{ formatDateRange(event.startAt, event.endAt) }}</span>
              </div>
              @if (event.place.name) {
              <div class="flex items-center gap-1.5">
                <app-icon name="material-symbols:location-on-rounded" class="size-4! shrink-0" />
                <span>{{ event.place.name }}</span>
              </div>
              }
            </div>
          </div>
        </a>
        } @empty {
        <app-not-found [isLoading]="$pastEvents.isLoading()" class="col-span-4">
          <span class="text-zinc-500 text-base">지난 박람회 내역이 없습니다.</span>
        </app-not-found>
        }
      </div>

      @if (pastEvents().length > 0) {
      <app-pagination
        [currentPage]="pastCurrentPage()"
        [totalPages]="pastTotalPages()"
        (pageChange)="onPastPageChange($event)"
        class="flex mt-10" />
      }
    </div>
    }
    }
  </div>
</main>
